import React from 'react';
import { Squad } from '../lib/supabase';
import './SquadSelection.css';

interface SquadSelectionProps {
  onSquadSelect: (squad: Squad) => void;
}

const SquadSelection: React.FC<SquadSelectionProps> = ({ onSquadSelect }) => {
  const squads: { key: Squad; name: string; color: string }[] = [
    {
      key: 'core',
      name: '<span style="color: #64B5F6;">Core</span> squad',
      color: '#64B5F6'
    },
    {
      key: 'sync',
      name: '<span style="color:#74d075;">Sync</span> squad',
      color: '#74d075'
    },
    {
      key: 'flow',
      name: '<span style="color: #FFA726;">Flow</span> squad',
      color: '#FFA726'
    }
  ];

  return (
    <div className="squad-selection">
      <h2>소속 스쿼드를 선택해주세요</h2>
      <p className="description">
        익명성을 보장하기 위해 본인의 소속 스쿼드를 선택해주세요.
      </p>
      <div className="squad-grid">
        {squads.map((squad) => (
          <button
            key={squad.key}
            className="squad-card"
            onClick={() => onSquadSelect(squad.key)}
            style={{ '--squad-color': squad.color } as React.CSSProperties}
          >
            <h3 dangerouslySetInnerHTML={{ __html: squad.name }}></h3>
          </button>
        ))}
      </div>
    </div>
  );
};

export default SquadSelection;
